import React from 'react';
import { ReferralSignUpInput } from '../ReferralSignUpInput';

export const FullNameInput = ({ t, errors, touched }) => {
  return <ReferralSignUpInput name="fullName" label={t('labelReferralFullName')} placeholder={t('placeholderReferralFullName')} errors={errors} touched={touched} />;
};
